import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { lazy } from 'react';
import { Root } from './App.tsx';

// Global error handler for chunk loading failures
const handleChunkError = (error: any) => {
  const message = error?.message || error?.toString() || '';
  // Check for known chunk load error patterns
  if (
    message.includes('Loading chunk') || 
    message.includes('CSS_CHUNK_LOAD_FAILED') ||
    message.includes('Importing a module script failed') // Safari specific
  ) {
    console.error('Chunk loading failed. Reloading page...', error);
    window.location.reload();
  }
};

window.addEventListener('error', (e) => handleChunkError(e));
window.addEventListener('unhandledrejection', (e) => handleChunkError(e.reason));

const Index = lazy(() => import('./pages/Index'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ProjectPage = lazy(() => import('./pages/ProjectPage').then(module => ({ default: module.ProjectPage })));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const CookiesPage = lazy(() => import('./pages/CookiesPage'));
const NotFound = lazy(() => import('./pages/NotFound'));
const EcommercePage = lazy(() => import('./pages/EcommercePage'));
import './index.css'
import '@fontsource/inter';
import '@fontsource/playfair-display';
import '@fontsource/press-start-2p';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Root />,
        children: [
            {
                path: '/',
                element: <Index />
            },
            {
                path: '/tjenester',
                element: <ServicesPage />
            },
            {
                path: '/om-oss',
                element: <AboutPage />
            },
            {
                path: '/arbeid/:projectName',
                element: <ProjectPage />
            },
            {
                path: '/ecommerce',
                element: <EcommercePage />
            },
            {
                path: '/personvern',
                element: <PrivacyPage />
            },
            {
                path: '/vilkar',
                element: <TermsPage />
            },
            {
                path: '/cookies',
                element: <CookiesPage />
            },
            {
                path: '*',
                element: <NotFound />
            }
        ]
    }
])

createRoot(document.getElementById("root")!).render(<RouterProvider router={router} future={{ v7_startTransition: true }} />);
